<template>
	<div class="slid-bar">
		<el-menu 
			:default-active="activeMenu" 
			class="el-menu-vertical-demo" 
			@open="handleOpen" 
			@close="handleClose"
			router
			unique-opened
		>
			<el-menu-item index="/" @click="goto('/')">
				<i class="el-icon-location"></i>
				<span slot="title">首页</span>
			</el-menu-item>
			
			<el-submenu v-for="menu in menuList" :key="menu.menuId" :index="menu.menuId">
				<template slot="title">
					<i :class="menu.menuIcon || 'el-icon-menu'"></i>
					<span>{{ menu.name }}</span>
				</template>
				<el-menu-item 
					v-for="child in menu.children" 
					:key="child.menuId" 
					:index="child.path"
					@click="goto(child.path)"
				>
					<i :class="child.menuIcon || 'el-icon-document'"></i>
					<span slot="title">{{ child.name }}</span>
				</el-menu-item>
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "SlidBar",
	
	computed: {
		...mapState({
			menuList: (state) => {
				if (!state.menuList || state.menuList.length === 0) {
					return [];
				}
				return buildTree(state.menuList);
			}
		}),
		
		// 当前激活的菜单项
		activeMenu() {
			const path = this.$route.path;
			return path;
		}
	},
	
	watch: {
		'$route.path': {
			handler(newPath) {
				console.log("当前路由:", newPath);
			},
			immediate: true
		}
	},
	
	methods: {
		handleOpen(key, keyPath) {
			console.log("菜单打开:", key, keyPath);
		},
		
		handleClose(key, keyPath) {
			console.log("菜单关闭:", key, keyPath);
		},
		
		goto(path) {
			if (path && path !== this.$route.path) {
				this.$router.push(path).catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						console.error("路由跳转失败:", err);
					}
				});
			}
		}
	}
};

function buildTree(list, rootId = "0") {
	const map = {};
	const tree = [];
	
	// 深拷贝避免修改原数据
	const cloneList = JSON.parse(JSON.stringify(list));
	
	// 初始化
	cloneList.forEach((item) => {
		item.children = [];
		map[item.menuId] = item;
	});
	
	// 构建树
	cloneList.forEach((item) => {
		const parentId = item.parentId;
		
		if (parentId === rootId) {
			tree.push(item);
		} else {
			const parent = map[parentId];
			if (parent) {
				parent.children.push(item);
			} else {
				console.warn(`警告：菜单项 ${item.menuName} 的父节点 ${parentId} 不存在`);
			}
		}
	});
	
	// 排序
	tree.sort((a, b) => (a.menuIndex || 0) - (b.menuIndex || 0));
	tree.forEach(item => {
		if (item.children && item.children.length) {
			item.children.sort((a, b) => (a.menuIndex || 0) - (b.menuIndex || 0));
		}
	});
	
	return tree;
}
</script>

<style scoped>
.slid-bar {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow-y: auto;
}

.slid-bar::-webkit-scrollbar {
	width: 6px;
}

.slid-bar::-webkit-scrollbar-thumb {
	background-color: #DCDFE6;
	border-radius: 3px;
}

.slid-bar::-webkit-scrollbar-thumb:hover {
	background-color: #C0C4CC;
}

/* 激活菜单高亮样式 */
.slid-bar >>> .el-menu-item.is-active {
	color: #409EFF;
	background-color: #ecf5ff;
}

.slid-bar >>> .el-submenu__title i {
	color: inherit;
}
</style>